import type { ReactNode } from 'react'
import { CircularProgressContinuousSized } from '@/components/loaders/CircularProgressContinuous'

export default function TableProcessingStatus({
  active,
  completed,
  total,
  children,
}: {
  active: boolean
  completed: number
  total: number
  children: ReactNode
}) {
  return (
    <div role="status" className="flex min-h-6 flex-wrap items-center gap-x-3 gap-y-1 text-sm text-brand-neutral-950">
      {active && (
        <span className="inline-flex items-center gap-2">
          <span aria-hidden="true" className="relative inline-flex h-5 w-5 shrink-0">
            <span className="absolute inset-0 rounded-full border-2 border-brand-neutral-300" />
            <CircularProgressContinuousSized size={20} thickness={4} hexColor="#0041FF" />
          </span>
          {completed} / {total} completed
        </span>
      )}
      {!active && <span className="font-semibold">{children}</span>}
    </div>
  )
}
